/** @internal */
export const UPSTREAM_BASELINE = {
    repo: "klinecharts/KLineChart",
    npmPackage: "klinecharts",
    pinnedTag: "v9.8.12",
    license: "Apache-2.0",
    docsLine: "9.8.12",
    pinnedRef: "03b2baf1e77af7ce82053a7a06038390d8c15921",
    vendorPath: "packages/vn-kline-engine-core/vendor/klinecharts-v9.8.12",
    sourceImported: true,
};
